// Apply filter to users and set filteredUsers

import { UserEntity } from '@finance-lab/utils/types'

export const applyFilter = (
    usersList: UserEntity[],
    filterState: { enabledDisabled: string; userCategory: string },
) => {
    let filtered = usersList

    if (filterState.enabledDisabled === 'enabled') {
        filtered = filtered.filter((user: UserEntity) => !user.disabled)
    } else if (filterState.enabledDisabled === 'disabled') {
        filtered = filtered.filter((user: UserEntity) => user.disabled)
    }

    if (filterState.userCategory !== 'all') {
        filtered = filtered.filter((user: UserEntity) => user.userCategory === filterState.userCategory)
    }

    return filtered
}
